import { Reveal, APP_STORE_URL } from "./booking";

export default function AppDownload() {
  return (
    <section
      id="app"
      data-testid="app-download-section"
      className="border-t border-border bg-primary text-primary-foreground"
    >
      <div className="px-5 lg:px-12 py-20 lg:py-28 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-primary-foreground/70 mb-6">
              Book Faded from your phone
            </p>
            <h2 className="font-display uppercase leading-[0.9] text-5xl sm:text-6xl lg:text-7xl">
              The Faded app.
              <br />
              Your chair, on demand.
            </h2>
            <p className="mt-6 max-w-lg text-base sm:text-lg font-light leading-relaxed text-primary-foreground/85">
              Download the Faded Barber Co. app for an easy way to book and manage your
              appointments.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:justify-self-end">
          <Reveal delay={0.15}>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="app-store-button"
              className="inline-flex items-center gap-4 bg-background text-foreground px-8 py-5 hover:bg-foreground hover:text-background transition-colors duration-300"
            >
              <svg viewBox="0 0 384 512" className="w-7 h-7 fill-current" aria-hidden="true">
                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
              </svg>
              <span className="text-left leading-tight">
                <span className="block font-mono text-[10px] tracking-[0.2em] uppercase opacity-70">
                  Download on the
                </span>
                <span className="block font-bold text-lg">App Store</span>
              </span>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
